<template>
  <div>
    <FormSectionContainer index="1" title="Hiteltermék adatai">
      <b-row>
        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="creditData.creditType">Hiteltermék típusa<span class="required-star"></span></label>
          <b-form-group>
            <b-form-input
              id="creditData.creditType"
              v-model="creditData.creditType"
              placeholder="Adja meg a hiteltermék típusát"
              trim
              class="mb-3"
              :state="creditType"
              :class="`${creditType !== null && !creditType ? 'create-fund-error-border' : ''}`"
            >
              <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
                Válassza ki a hitel típusát
              </b-form-invalid-feedback>
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="creditData.creditServiceProvider">Szolgáltató<span class="required-star"></span></label>
          <b-form-group>
            <b-form-select
              class="dropdown-border mb-3"
              v-model="creditData.creditServiceProvider"
              :options="serviceProviderOptions"
              id="creditData.creditServiceProvider"
              :state="creditServiceProvider"
              :class="`${creditServiceProvider !== null && !creditServiceProvider ? 'create-fund-error-border' : ''}`"
            >
              <template #first>
                <b-form-select-option id="creditData.creditServiceProvider" :value="null" disabled>
                  Válassza ki a hitel szolgáltatóját
                </b-form-select-option>
              </template>
              <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
                Válassza ki a hitel szolgáltatóját
              </b-form-invalid-feedback>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <label for="creditData.creditCurrency">Devizanem<span class="required-star"></span></label>
          <b-form-group>
            <b-form-select
              class="dropdown-border mb-3"
              v-model="creditData.creditCurrency"
              :options="currencyOptions"
              id="creditData.creditCurrency"
              :state="creditCurrency"
              :class="`${creditCurrency !== null && !creditCurrency ? 'create-fund-error-border' : ''}`"
            >
              <template #first>
                <b-form-select-option id="creditData.creditCurrency" :value="null" disabled>
                  Válassza ki milyen devizában kerül folyósításra a hitel
                </b-form-select-option>
              </template>
              <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
                Válassza ki milyen devizában kerül folyósításra a hitel
              </b-form-invalid-feedback>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <label for="creditData.creditDescription">Hitelösszeg megállapítása</label>
      <b-form-textarea
        id="creditData.creditDescription"
        v-model="creditData.creditDescription"
        placeholder="Adja meg a hitelösszeg megállapításának módját"
        trim
        rows="6"
        style="min-height: 150px;"
        class="mb-3"
      ></b-form-textarea>
      <b-row>
        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="creditData.creditMin">Min. összeg</label>
          <div
            :class="
              `${
                creditData.creditCurrency === 'EUR'
                  ? 'input-symbol-euro'
                  : creditData.creditCurrency === 'USD'
                  ? 'input-symbol-dollar'
                  : 'input-symbol-forint'
              }`
            "
          >
            <b-form-input
              id="creditData.creditMin"
              v-model="creditData.creditMin"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg a hitelösszeg minimumát"
              trim
              class="mb-3"
            ></b-form-input>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="6" xl="6"
          ><label for="creditData.creditMax">Max. összeg</label>
          <div
            :class="
              `${
                creditData.creditCurrency === 'EUR'
                  ? 'input-symbol-euro'
                  : creditData.creditCurrency === 'USD'
                  ? 'input-symbol-dollar'
                  : 'input-symbol-forint'
              }`
            "
          >
            <b-form-input
              id="creditData.creditMax"
              v-model="creditData.creditMax"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg a hitelösszeg maximumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>
    </FormSectionContainer>

    <FormSectionContainer index="2" title="Kamat">
      <b-row>
        <b-col cols="12">
          <label for="interest.interestType">Kamat típusa<span class="required-star"></span></label>
          <b-form-group>
            <b-form-select
              class="dropdown-border mb-2"
              v-model="interest.interestType"
              :options="interestTypeOptions"
              id="interest.interestType"
              :state="interestType"
              :class="`${interestType !== null && !interestType ? 'create-fund-error-border' : ''}`"
            >
              <template #first>
                <b-form-select-option id="interest.interestType" :value="null" disabled>
                  Válassza ki, hogy fix-, vagy változó kamatú a hiteltermék
                </b-form-select-option>
              </template>
              <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
                Válassza ki a kamat típusát
              </b-form-invalid-feedback>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mb-3">
          <label for="interest.interest">Kamat (szövegesen megjelenő)<span class="required-star"></span></label>
          <b-form-input
            id="interest.interest"
            v-model="interest.interest"
            placeholder="Adja meg a kamat értékét."
            trim
            :state="interestValue"
            :class="`${interestValue !== null && !interestValue ? 'create-fund-error-border' : ''}`"
          ></b-form-input>
          <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
            Adja meg a kamatot
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="interest.interestMin">Kamat minimuma</label>
          <b-form-input
            id="interest.interestMin"
            v-model="interest.interestMin"
            @keypress="isNumber($event, true)"
            placeholder="Adja meg a kamat minimumát"
            trim
            class="mb-3"
          ></b-form-input
        ></b-col>
        <b-col cols="12" md="6" lg="6" xl="6"
          ><label for="interest.interestMax">Kamat maximuma</label>
          <b-form-input
            id="interest.interestMax"
            v-model="interest.interestMax"
            @keypress="isNumber($event, true)"
            placeholder="Adja meg a kamat maximumát"
            trim
            class="mb-3"
          ></b-form-input>
        </b-col>
      </b-row>

      <label for="interest.repaymentRate">Törlesztés üteme<span class="required-star"></span></label>
      <b-form-input
        id="interest.repaymentRate"
        v-model="interest.repaymentRate"
        placeholder="Adja meg a törlesztés ütemét"
        trim
        class="mb-3"
        :state="repaymentRate"
        :class="`${repaymentRate !== null && !repaymentRate ? 'create-fund-error-border' : ''}`"
      ></b-form-input>
      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        Adja meg a törlesztés ütemét
      </b-form-invalid-feedback>

      <label for="interest.rateOfInterestRate">Kamatfizetés üteme</label>
      <b-form-input
        id="interest.rateOfInterestRate"
        v-model="interest.rateOfInterestRate"
        placeholder="Adja meg a kamatfizetés ütemét"
        trim
      ></b-form-input>
    </FormSectionContainer>

    <FormSectionContainer index="3" title="Saját erő és Futamidő">
      <div v-for="claim in creditDuration.claims" v-bind:key="claim.id">
        <b-row class="mb-4">
          <b-col cols="11">
            <label for="claim">Saját erő</label>
            <b-form-input
              id="claim"
              v-model="claim.claimText"
              placeholder="Adja meg a jogcím megnevezését"
              trim
              @input="onClaimChange(claim.id, claim.claimText, claim.claimValue)"
            ></b-form-input>
          </b-col>
          <b-col class="d-none" cols="10" sm="3" md="3" lg="3" xl="3">
            <label for="claimValue">Mérték</label>
            <div :class="`${claim.claimValue.length > 0 ? 'input-symbol-percent' : ''}`">
              <b-form-input
                id="claimValue"
                v-model="claim.claimValue"
                @keypress="isNumber($event, true)"
                placeholder="0"
                trim
                @input="onClaimChange(claim.id, claim.claimText, claim.claimValue)"
              ></b-form-input>
            </div>
          </b-col>
          <b-col cols="1" v-if="claim.id !== '0'" class=" trash-icon">
            <font-awesome-icon
              icon="fa-solid fa-trash"
              class="d-flex justify-content-center align-items-center"
              @click="deleteClaim(claim.id)"
            />
          </b-col>
        </b-row>
      </div>
      <p class="mt-3 d-flex justify-content-end mr-5 cursor-pointer" @click="addExtraClaim">
        <strong> + Jogcím hozzáadása</strong>
      </p>

      <div style="border-bottom: 1px solid #BBC1D3"></div>
      <label class="col-6 col-sm-4 col-md-4 col-lg-5 col-xl-5 mt-4" for="creditDuration.repaymentMin"
        >Futamidő minimuma</label
      >
      <label class="col-6 col-sm-4 col-md-4 col-lg-5 col-xl-5 mt-4" for="creditDuration.repaymentMax"
        >Futamidő maximuma<span class="required-star"></span>
      </label>
      <b-row class="mb-4">
        <b-col cols="6" sm="4" md="4" lg="5" xl="5">
          <b-form-input
            id="creditDuration.repaymentMin"
            v-model="creditDuration.repaymentMin"
            @keypress="isNumber($event, true)"
            placeholder="Minimum"
            trim
          ></b-form-input
        ></b-col>

        <b-col cols="6" sm="4" md="4" lg="5" xl="5">
          <b-form-input
            id="creditDuration.repaymentMax"
            v-model="creditDuration.repaymentMax"
            @keypress="isNumber($event, true)"
            placeholder="Maximum"
            trim
            :state="repaymentMax"
            :class="`${repaymentMax !== null && !repaymentMax ? 'create-fund-error-border' : ''}`"
          ></b-form-input>
          <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
            Adja meg a futamidő maximumát
          </b-form-invalid-feedback>
        </b-col>
        <b-col cols="12" sm="4" md="4" lg="2" xl="2">
          <b-row class="d-flex justify-content-start align-items-center radio-button">
            <input
              type="radio"
              id="creditDuration.repaymentType_radio_month"
              value="month"
              v-model="creditDuration.repaymentType"
            />
            <label class="radio-text mt-2" for="radio_month">Hónap </label>
            <input
              type="radio"
              id="creditDuration.repaymentType_radio_year"
              value="year"
              v-model="creditDuration.repaymentType"
              class="ml-2"
            />
            <label class="radio-text mt-2" for="radio_year">Év </label>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" sm="8" md="8" lg="4" xl="4" class="mt-3">
          <label for="creditDuration.availabilityTimeValue">Rendelkezésre tartási idő</label>
          <b-form-input
            id="creditDuration.availabilityTimeValue"
            v-model="creditDuration.availabilityTimeValue"
            @keypress="isNumber($event, true)"
            placeholder="Adja meg a rendelkezésre tartási időt"
            trim
          ></b-form-input>
        </b-col>

        <b-col cols="12" sm="4" md="4" lg="2" xl="2" class="mt-3 mt-sm-5">
          <b-row class="d-flex justify-content-start align-items-center radio-button">
            <input
              type="radio"
              id="availabilityTimeType_radio_month"
              value="month"
              v-model="creditDuration.availabilityTimeType"
            />
            <label class="radio-text mt-2" for="radio_month">Hónap </label>

            <input
              type="radio"
              id="availabilityTimeType_radio_year"
              value="year"
              v-model="creditDuration.availabilityTimeType"
              class="ml-2"
            />
            <label class="radio-text mt-2" for="radio_year">Év </label>
          </b-row>
        </b-col>

        <b-col cols="12" sm="8" md="8" lg="4" xl="4" class="mt-3">
          <label for="creditDuration.gracePeriodValue">Türelmi idő</label>
          <b-form-input
            id="creditDuration.gracePeriodValue"
            v-model="creditDuration.gracePeriodValue"
            @keypress="isNumber($event, true)"
            placeholder="Adja meg a türelmi időt"
            trim
          ></b-form-input>
        </b-col>

        <b-col cols="12" sm="4" md="4" lg="2" xl="2" class="mt-3 mt-sm-5">
          <b-row class="d-flex justify-content-start align-items-center radio-button">
            <input
              type="radio"
              id="creditDuration.gracePeriod_radio_month"
              value="month"
              v-model="creditDuration.gracePeriodType"
            />
            <label class="radio-text mt-2" for="radio_month">Hónap </label>

            <input
              type="radio"
              id="creditDuration.gracePeriod_radio_year"
              value="year"
              v-model="creditDuration.gracePeriodType"
              class="ml-2"
            />
            <label class="radio-text mt-2" for="radio_year">Év </label>
          </b-row>
        </b-col>
      </b-row>
    </FormSectionContainer>

    <FormSectionContainer
      index="4"
      title="Biztosítékok, hitelgarancia"
      :key="this.guarantee.uniqueConditions[0] ? this.guarantee.uniqueConditions[0].id : 'unqiue'"
    >
      <label for="guarantee.guaranteeDescription">Biztosítékok</label>
      <b-form-textarea
        id="guarantee.guaranteeDescription"
        v-model="guarantee.guaranteeDescription"
        placeholder="Adja meg a termékhez kapcsolódó kötelező biztosítékokat"
        trim
        rows="6"
        style="min-height: 150px;"
        class="mb-3"
      ></b-form-textarea>

      <UniqueConditionsSelector
        @unique-conditions="handleUniqueConditions($event)"
        :alreadySelected="guarantee.uniqueConditions"
      />
    </FormSectionContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as CompetitionApi from '../../../api/competition'
import FormSectionContainer from '../components/FormSectionContainer.vue'
import UniqueConditionsSelector from '../components/UniqueConditionsSelector.vue'
export default {
  props: {
    isTouched: { type: Boolean, required: true }
  },
  data() {
    return {
      creditData: {
        creditType: null,
        creditServiceProvider: null,
        creditCurrency: null,
        creditDescription: '',
        creditMin: '',
        creditMax: ''
      },
      interest: {
        interestType: null,
        interest: '',
        interestMin: '',
        interestMax: '',
        repaymentRate: '',
        rateOfInterestRate: ''
      },
      creditDuration: {
        claims: [{ id: '0', claimText: '', claimValue: '' }],
        repaymentMin: '',
        repaymentMax: '',
        repaymentType: 'month',
        availabilityTimeValue: '',
        availabilityTimeType: 'month',
        gracePeriodValue: '',
        gracePeriodType: 'month'
      },
      guarantee: {
        guaranteeDescription: '',
        uniqueConditions: []
      },
      serviceProviderOptions: [
        { value: 'MFB', text: 'MFB' },
        { value: 'KAVOSZ', text: 'KAVOSZ' },
        { value: 'EXIM', text: 'EXIM' },
        { value: 'OTHER', text: 'EGYÉB' }
      ],
      currencyOptions: [
        { value: 'HUF', text: 'HUF' },
        { value: 'EUR', text: 'EUR' },
        { value: 'USD', text: 'USD' }
      ],
      interestTypeOptions: [
        { value: 'FIX_INTEREST', text: 'Fix kamatozású' },
        { value: 'FLOATING_INTEREST', text: 'Változó kamatozású' },
        { value: 'NO_INTEREST', text: 'Kamatmentes' }
      ],
      touched: this.isTouched
    }
  },
  components: {
    FormSectionContainer,
    UniqueConditionsSelector
  },
  computed: {
    ...mapGetters(['newFundDto']),
    creditType() {
      if (this.touched) {
        return this.creditData.creditType !== null
      } else {
        return null
      }
    },
    creditServiceProvider() {
      if (this.touched) {
        return this.creditData.creditServiceProvider !== null
      } else {
        return null
      }
    },
    creditCurrency() {
      if (this.touched) {
        return this.creditData.creditCurrency !== null
      } else {
        return null
      }
    },
    interestType() {
      if (this.touched) {
        return this.interest.interestType !== null
      } else {
        return null
      }
    },
    interestValue() {
      if (this.touched) {
        return this.interest.interest.length > 0
      } else {
        return null
      }
    },
    repaymentRate() {
      if (this.touched) {
        return this.interest.repaymentRate.length > 0
      } else {
        return null
      }
    },

    repaymentMax() {
      if (this.touched) {
        return this.creditDuration.repaymentMax !== ''
      } else {
        return null
      }
    },
    finalResult() {
      if (
        this.creditData.creditType !== null &&
        this.creditData.creditServiceProvider !== null &&
        this.creditData.creditCurrency !== null &&
        this.interest.interestType !== null &&
        this.interest.interest.length > 0 &&
        this.interest.repaymentRate.length > 0 &&
        this.creditDuration.repaymentMax !== ''
      ) {
        return this.$emit('is-step2-fields-filled', true)
      } else {
        return this.$emit('is-step2-fields-filled', false)
      }
    }
  },
  methods: {
    isNumber(evt, isMinusAllowed) {
      const isStarting0Allowed = !this.$route.path.includes('/create-fund')
      const input = evt.target.value
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = evt.key

      if (keyPressed === '-' && input.length === 0 && isMinusAllowed) {
        return
      }

      if (input.length === 0 && keyPressed === '0' && isStarting0Allowed) {
        evt.preventDefault()
        return
      }

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    addCompetitionAttribute(key, value) {
      this.$store.dispatch('setFundDtoPropertyAction', { [key]: value })
    },
    handleUniqueConditions(conditions) {
      this.guarantee.uniqueConditions = conditions
    },
    onClaimChange(id, claimText, claimValue) {
      const newArr = this.creditDuration.claims
        .map(claim => {
          if (claim.id === id) {
            return { id, claimText: claimText, claimValue: claimValue }
          }
          return claim
        })
        .filter(x => x !== undefined)
      this.creditDuration.claims = newArr
    },
    addExtraClaim() {
      let newItem = {
        id: (Number(this.creditDuration.claims[this.creditDuration.claims.length - 1].id) + 1).toString(),
        claimText: '',
        claimValue: ''
      }
      this.creditDuration.claims.push(newItem)
    },
    deleteClaim(id) {
      const newArr = this.creditDuration.claims
        .map(claim => {
          if (claim.id === id) {
            return
          }
          return claim
        })
        .filter(x => x !== undefined)
      this.creditDuration.claims = newArr
    }
  },
  watch: {
    creditData: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('creditData', value)
      },
      deep: true
    },
    interest: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('interest', value)
      },
      deep: true
    },
    creditDuration: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('creditDuration', value)
      },
      deep: true
    },
    guarantee: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('guarantee', value)
      },
      deep: true
    },
    isTouched() {
      this.touched = this.isTouched
    }
  },
  async beforeMount() {
    const { competitionId } = this.$route.query
    if (competitionId) {
      try {
        const fundResult = await CompetitionApi.getCompetitionWithDetails(competitionId)

        this.creditData = fundResult.fundId.creditData

        this.interest = fundResult.fundId.interest

        this.creditDuration = fundResult.fundId.creditDuration

        this.guarantee = fundResult.fundId.guarantee
      } catch (e) {
        console.log(e)
      }
    } else {
      if (this.newFundDto.creditData) {
        this.creditData = this.newFundDto.creditData
      }
      if (this.newFundDto.interest) {
        this.interest = this.newFundDto.interest
      }
      if (this.newFundDto.creditDuration) {
        this.creditDuration = this.newFundDto.creditDuration
      }
      if (this.newFundDto.guarantee) {
        this.guarantee = this.newFundDto.guarantee
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-text {
  font-weight: 400;
  font-size: 14px;
  color: black;
  text-transform: none;
}

input[type='radio'] {
  width: 20px;
  height: 20px;
  border: 1px solid #bbc1d3;
}

input[type='radio']:after {
  border-radius: 20px;
  content: '';
  display: inline-block;
}

input[type='radio']:checked:after {
  width: 20px;
  height: 20px;
  background-color: white;
  border: 6px solid #00903c;
}

.dropdown-border {
  border: 2px solid #b2bec3 !important;
}

.trash-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  cursor: pointer;
}

.radio-button {
  margin-top: 5px;
}

@media all and (max-width: 576px) {
  .radio-button {
    margin-left: 10px;
    margin-top: 10px;
  }
}

.create-fund-error-border {
  border: 2px solid #ba3b46 !important;
}

.create-fund-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}
</style>
